<template>
  <div :class="{ highlight: facility.isActive }" @click="highlight()">
    {{ facility.facilityname }}
  </div>
</template>

<script>
export default {
  props: ["facility"],
  methods: {
    highlight() {
			this.facility.isActive = !this.facility.isActive
      this.$emit("highlight", this.facility);
    }
  }
};
</script>

<style scoped>
div {
  padding: 0 1rem 0 1rem;
  margin: 1rem 0 1rem 0;
}

.highlight {
  color: black;
  background-color: lightblue;
}
</style>
